'use client'
import clsx from "clsx"
import { useMemo, useState } from "react"
import { ScreenWrapper } from "./ScreenWrapper"
import Image from "next/image"

const frequentlyQuestions = [
    {
        id: 1,
        question: 'O que foi a promoção de Aniversário da Bradesco Consórcios?',
        answer: 'A promoção aconteceu de 02/01/2025 até 31/03/2025 e vai sortear R$ 120 mil para quem contratou uma ou mais cotas de Consórcios Bradesco, sem valor mínimo'
    },
    {
        id: 2,
        question: 'Qual é o prêmio? Quantas pessoas ganham?',
        answer: 'O prêmio é de R$ 120 mil na conta para uma pessoa sorteada.'
    },
    {
        id: 3,
        question: 'Quem podia participar?',
        answer: 'Pessoa física ou jurídica, com ou sem conta Bradesco.'
    },
    {
        id: 4,
        question: 'Qual foi o período de participação?',
        answer: 'A promoção era válida para todas as pessoas que contrataram uma cota ou mais cotas de Consórcio Bradesco entre 02/01/2025 até o dia 31/03/2025.'
    },
    {
        id: 5,
        question: 'Quais eram os requisitos para participar?',
        answer: 'Para quem fez a contratação de uma ou mais cotas de Consórcio de 02/01/2025 até dia 31/03/2025, a participação no sorteio será automática. Cada cota deu o direito a 1 número da sorte. Quanto mais cotas contratadas, mais chances de ganhar.'
    },
    {
        id: 6,
        question: 'Não quero participar da promoção. O que devo fazer?',
        answer: 'É só ligar na nossa central de atendimento e pedir o descadastramento da promoção. 4004 4436 capitais e regiões metropolitanas 0800 722 4436 outras regiões Em dias úteis, das 8h às 20h, horário de Brasília (exceto feriados).'
    },
    {
        id: 7,
        question: 'O que é uma cota de consórcio?',
        answer: 'Quando um grupo de Consórcio é formado, ele é dividido em cotas, que são distribuídas entre todos os participantes. Nesta promoção, para cada cota contratada, você recebe 1 número da sorte para concorrer ao prêmio de R$ 120 mil.'
    },
    {
        id: 8,
        question: 'Quando será o sorteio?',
        answer: 'O sorteio será feito com base nos números extraídos pela divulgação da Loteria Federal do Brasil, no dia 17/05/2025.'
    },
    {
        id: 9,
        question: 'Como será divulgado o resultado da promoção?',
        answer: 'O resultado será divulgado neste site, e o ganhador será avisado em até 10 dias após o sorteio.'
    },
    {
        id: 10,
        question: 'Como vejo meu número da sorte?',
        answer: 'Até o dia 15/05/2025, os números da sorte serão enviados por SMS no celular cadastrado na contratação do Consórcio. Além disso, dá para conferir em uma de nossas agências.'
    },
    {
        id: 11,
        question: 'Como atualizo o número de telefone no meu cadastro?',
        answer: 'Acesse o Canal do Consorciado e escolha Serviços > Dados cadastrais > Alterar dados cadastrais.'
    },
    {
        id: 12,
        question: 'Tenho outras dúvidas. O que posso fazer?',
        answer: 'Você pode consultar o regulamento completo da promoção <a style="font-weight: 700;text-decoration: underline;color:#3B69FF;" href="./assets/pdf/regulamento-aniversario-consorcio-bradesco.pdf" target="_blank">neste link<a/>. Caso tenha mais alguma dúvida, entre em contato com a nossa central de atendimento: 4004 4436 capitais e regiões metropolitanas 0800 722 4436 outras regiões Em dias úteis, das 8h às 20h, horário de Brasília (exceto feriados).'
    },
]


export const FrequentlyQuestions = () => {

    const [activeQuestion, setActiveQuestion] = useState(0)


    const [toggleList, setToggleList] = useState(true)
    const questionsList = useMemo(() => {
        if (toggleList) {
            return frequentlyQuestions.slice(0, 4)
        }
        return frequentlyQuestions
    }, [toggleList])

    const handleShowAnswer = (questionId: number) => {
        if (questionId === activeQuestion) {
            return setActiveQuestion(0)
        }
        return setActiveQuestion(questionId)
    }

    return (
        <section id="perguntas-frequentes" className="bg-[#F0F1F5] pb-16">
            <ScreenWrapper>
                <header className="hidden lg:block lg:pt-14 lg:pb-8">
                    <h4 className="text-[#333B8F] text-center text-5xl font-extralight">Perguntas Frequentes</h4>
                </header>
                <div className="p-8 lg:hidden">
                    <h4 className="text-[#333B8F] text-[28px] text-center">Ficou alguma dúvida?</h4>
                    <p className="text-base text-center">Confira as perguntas mais frequentes sobre o Consórcio Premiado Bradesco.</p>
                </div>
                <div className="p-8 flex flex-col gap-4">
                    {questionsList.map(({ id, answer, question }) => {
                        return (
                            <div key={id} className="bg-white p-4 mb-2" onClick={() => handleShowAnswer(id)}>
                                <div className="flex flex-row justify-between">
                                    <p className="text-base font-semibold">{question}</p>
                                    <div className="w-24 h-6 flex items-center justify-end">
                                    <Image src="./assets/images/svg/arrow-blue-big.svg" width={18} height={18} className={clsx({
                                        'rotate-0': activeQuestion !== id,
                                        'rotate-180': activeQuestion === id
                                    })} alt="indicador para mostrar a resposta da pergunta" />
                                    </div>
                                </div>
                                <p className={clsx('overflow-hidden transition-all duration-500 ease-in-out', {
                                    'max-h-0': activeQuestion !== id,
                                    'max-h-52': activeQuestion === id
                                })} dangerouslySetInnerHTML={{__html: answer}}></p>
                            </div>
                        )
                    })}
                </div>
                <div className="flex flex-col items-center gap-12">
                    <span className="text-[#3B69FF] text-sm font-semibold cursor-pointer" onClick={() => setToggleList(prev => !prev)}>Ver mais {toggleList ? '+' : '-'} </span>
                    <div className="flex flex-row items-center justify-center gap-2 cursor-pointer">
                        <span className="text-[#E1173F] text-sm font-bold" onClick={() => window.scrollTo(0, 0)}>Voltar ao topo</span>
                        <Image onClick={() => window.scrollTo(0, 0)} src="./assets/images/svg/arrow-red.svg" width={18} height={18} alt="indicador para voltar ao todo da pagina" />
                    </div>
                </div>
            </ScreenWrapper>
        </section>
    )
}